import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

export default class extends Controller {
  static targets = ["date", "publishedOn", "publishedHour", "publishedMinute"];

  connect() {
    if (this.hasDateTarget) {
      this.initFlatpickr();
    }
  }

  initFlatpickr() {
    this.flatpickrInstance = flatpickr(this.dateTarget, {
      locale: Japanese,
      static: true,
      dateFormat: "Y/m/d",
      disableMobile: true,
      allowInput: true,
      wrap: true,
      clickOpens: false,
    });
  }

  // modal_controller.jsのshowを呼び出す
  modalShow(event) {
    const targetId = event.currentTarget.dataset.targetId;
    if (targetId === "dialog-release") {
      this.updatePublishText();
    }
    const modalController = this.application.getControllerForElementAndIdentifier(
      document.getElementById(targetId),
      "modal",
    );
    modalController.show();
  }

  updatePublishText() {
    const publishTypeInput = document.querySelector('input[name="form[published_type]"]:checked');
    if (!publishTypeInput) {
      return; // ラジオボタン（公開日時入力項目）がない場合、処理を終了
    }
    const publishType = publishTypeInput.value;
    const publishText = document.getElementById("publish-text");
    if (publishType === "scheduled") {
      const date = this.publishedOnTarget.value;
      const hour = this.publishedHourTarget.value;
      const minute = this.publishedMinuteTarget.value;
      if (date && hour && minute) {
        const datetime = new Date(`${date} ${hour}:${minute}`);
        const formattedDateTime = datetime.toLocaleString("ja-JP", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          weekday: "short",
          hour: "2-digit",
          minute: "2-digit",
        });
        publishText.textContent = `${formattedDateTime}に`;
      }
    } else {
      publishText.textContent = null;
    }
  }
}
